






























































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Mixin } from "@/core/mixins/mixin";
import { NavBar, Row, Image } from "vant";
@Component({
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Image.name]: Image,
  },
})
export default class MallItem extends Mixins(Mixin) {
  @Prop({
    type: Object,
    default: () => {
      return {};
    },
  })
  public itemInfo!: good.CommodityDto;

  goDetails(itemInfo?: good.CommodityDto): void {
    this.$emit("goDetails", itemInfo);
  }
}
